import { RSAA } from 'redux-api-middleware';
import config from 'config';

export const GET_CLIENT_DETAILS_REQUEST = 'GET_CLIENT_DETAILS_REQUEST';
export const GET_CLIENT_DETAILS_SUCCESS = 'GET_CLIENT_DETAILS_SUCCESS';
export const GET_CLIENT_DETAILS_FAILURE = 'GET_CLIENT_DETAILS_FAILURE';

export const UPDATE_CLIENT_DETAILS_REQUEST = 'UPDATE_CLIENT_DETAILS_REQUEST';
export const UPDATE_CLIENT_DETAILS_SUCCESS = 'UPDATE_CLIENT_DETAILS_SUCCESS';
export const UPDATE_CLIENT_DETAILS_FAILURE = 'UPDATE_CLIENT_DETAILS_FAILURE';

export const GET_FAX_TEMPLATES_REQUEST = 'GET_FAX_TEMPLATES_REQUEST';
export const GET_FAX_TEMPLATES_SUCCESS = 'GET_FAX_TEMPLATES_SUCCESS';
export const GET_FAX_TEMPLATES_FAILURE = 'GET_FAX_TEMPLATES_FAILURE';

export const GET_SENSITIVE_FIELDS_REQUEST = 'GET_SENSITIVE_FIELDS_REQUEST';
export const GET_SENSITIVE_FIELDS_SUCCESS = 'GET_SENSITIVE_FIELDS_SUCCESS';
export const GET_SENSITIVE_FIELDS_FAILURE = 'GET_SENSITIVE_FIELDS_FAILURE';



export const getClientDetails = (clientInfoUuid) => {
  return {
    [RSAA]: {
      endpoint: `${config.customersApiServiceRoot}/clients/${clientInfoUuid}`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        GET_CLIENT_DETAILS_REQUEST,
        GET_CLIENT_DETAILS_SUCCESS,
        GET_CLIENT_DETAILS_FAILURE
      ]
    }
  };
};

export const getFaxTemplates = () => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/templates/list`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        GET_FAX_TEMPLATES_REQUEST,
        {
          type: GET_FAX_TEMPLATES_SUCCESS,
          payload: async (action, state, res) => {
            const text = await res.text();
            try {
              // Try to clean up common JSON issues (trailing commas)
              const cleanedText = text.replace(/,(\s*[}\]])/g, '$1');
              const data = JSON.parse(cleanedText);
              return data;
            } catch (error) {
              console.error('Error parsing fax templates response:', error);
              console.error('Response text:', text);
              throw error;
            }
          }
        },
        GET_FAX_TEMPLATES_FAILURE
      ]
    }
  };
};

export const updateClientDetails = (clientInfoUuid, clientData) => {
  return {
    [RSAA]: {
      endpoint: `${config.customersApiServiceRoot}/clients/${clientInfoUuid}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(clientData),
      types: [
        UPDATE_CLIENT_DETAILS_REQUEST,
        UPDATE_CLIENT_DETAILS_SUCCESS,
        UPDATE_CLIENT_DETAILS_FAILURE
      ]
    }
  };
};

export const getSensitiveFields = (propertyCode) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/lookups/fetch/${propertyCode}`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        GET_SENSITIVE_FIELDS_REQUEST,
        {
          type: GET_SENSITIVE_FIELDS_SUCCESS,
          payload: async (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && contentType.includes('application/json')) {
              return await res.json();
            } else {
              return await res.text();
            }
          }
        },
        GET_SENSITIVE_FIELDS_FAILURE
      ]
    }
  };
};
